module.exports = __webpack_public_path__ + "img/user_WangYongjun.baec1203.jpg";